export const TOTAIS_DASHBOARD_FINANCEIRO = 'TOTAIS_DASHBOARD_FINANCEIRO'

export const TOTAIS_DASHBOARD_FINANCEIRO_PENDING = 'TOTAIS_DASHBOARD_FINANCEIRO_PENDING'
export const TOTAIS_DASHBOARD_FINANCEIRO_SUCCESS = 'TOTAIS_DASHBOARD_FINANCEIRO_SUCCESS'
export const TOTAIS_DASHBOARD_FINANCEIRO_FAILURE = 'TOTAIS_DASHBOARD_FINANCEIRO_FAILURE'

export const GRAFICO_SALDO_CONTAS_DASHBOARD_FINANCEIRO_PENDING = 'GRAFICO_SALDO_CONTAS_DASHBOARD_FINANCEIRO_PENDING'
export const GRAFICO_SALDO_CONTAS_DASHBOARD_FINANCEIRO_SUCCESS = 'GRAFICO_SALDO_CONTAS_DASHBOARD_FINANCEIRO_SUCCESS'
export const GRAFICO_SALDO_CONTAS_DASHBOARD_FINANCEIRO_FAILURE = 'GRAFICO_SALDO_CONTAS_DASHBOARD_FINANCEIRO_FAILURE'
